<div class="form-view-container">
    <h2 class="fw-bold mb-3 text-center text-light">Account Recovery</h2>
    <p class="form-instruction text-center mb-4">Enter your username and we'll send you a passcode to recover your
        account.</p>
    <form (ngSubmit)="sendRecoveryLink()">
        <!-- Recovery Email Input -->
        <div class="form-floating mb-3">
            <input type="text" class="form-control" id="recoveryUsername" name="recoveryUsername" placeholder="USERNAME"
                autocomplete="username" [ngModel]="recoveryUsername()" (ngModelChange)="recoveryUsername.set($event)" required>
            <label for="recoveryUsername">USERNAME</label>
        </div>

        <!-- Recovery Method Selection -->
        <fieldset class="border-0 p-0 m-0 mb-4 text-start">
            <legend class="visually-hidden">Choose recovery method</legend>
            <div class="d-flex gap-3">
                <label
                    class="form-check form-check-inline flex-grow-1 rounded p-3 d-flex align-items-center m-0 method-container"
                    for="methodEmail">
                    <input class="form-check-input ms-0 me-2" type="radio" name="requestedMethod" id="methodEmail"
                        [value]="0" [ngModel]="requestedMethod()" (ngModelChange)="requestedMethod.set($event)">
                    <span class="form-check-label text-light fw-bold m-0">Email</span>
                </label>
                <label
                    class="form-check form-check-inline flex-grow-1 rounded p-3 d-flex align-items-center m-0 method-container"
                    for="methodSms">
                    <input class="form-check-input ms-0 me-2" type="radio" name="requestedMethod" id="methodSms"
                        [value]="1" [ngModel]="requestedMethod()" (ngModelChange)="requestedMethod.set($event)">
                    <span class="form-check-label text-light fw-bold m-0">SMS / Text</span>
                </label>
            </div>
        </fieldset>

        <!-- Submit Button -->
        <div class="mt-4">
            <button type="submit"
                class="btn btn-danger w-100 d-flex align-items-center justify-content-center btn-submit"
                style="height: 4rem;" [disabled]="!recoveryUsername()"
                aria-label="Send recovery code" title="Recover">
                <svg class="send-icon text-white" style="width: 2rem; height: 2rem;" fill="currentColor"
                    viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
                </svg>
            </button>
        </div>
    </form>
    <div class="mt-5 text-center small login-links">
        <a href="#" (click)="$event.preventDefault(); changeView.emit('login')" role="button"
            class="fw-bold text-decoration-none text-uppercase login-link">Back to Sign In</a>
    </div>
</div>